import {
  SuperAdmin,
  CreateSuperAdminDTO,
  UpdateSuperAdminDTO,
} from '@/interface/types/user'
import { api } from '../axios-instance'

export const superAdminService = {
  getAll: async () => {
    const response = await api.get<SuperAdmin[]>('/super-admin')
    return response.data
  },

  getById: async (id: string) => {
    const response = await api.get<SuperAdmin>(`/super-admin/${id}`)
    return response.data
  },

  create: async (data: CreateSuperAdminDTO) => {
    const response = await api.post<SuperAdmin>('/super-admin', data)
    return response.data
  },

  update: async (id: string, data: UpdateSuperAdminDTO) => {
    const response = await api.patch<SuperAdmin>(`/super-admin/${id}`, data)
    return response.data
  },

  delete: async (id: string) => {
    await api.delete(`/super-admin/${id}`)
  },

  activate: async (id: string) => {
    const response = await api.patch<SuperAdmin>(`/super-admin/${id}/activate`)
    return response.data
  },

  deactivate: async (id: string) => {
    const response = await api.patch<SuperAdmin>(
      `/super-admin/${id}/deactivate`,
    )
    return response.data
  },
}